import React, { Component, useState } from "react";
import useValidationInput from "../../../Hooks/useValidationInput.js";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import useLogIcon from "../../../Hooks/useLogIcon.js";
import { useLocation } from "react-router-dom";
import "../../Styles/globalStyle.css";

export default function ResetPassword (props) {
  const axiosOperation = useAxiosOperation();
  const isInputValid = useValidationInput();
  const getLogIcon = useLogIcon();
  const  [user, setUser] = useState({ 
    id: 1,
    email : "",
    password : "",
    errors:[],
    loading:false,
    company: {id:new URLSearchParams(useLocation().search).get("id"), siteName:new URLSearchParams(useLocation().search).get("siteName")}
  })

  const getError = (id) => {
    const error =  user.errors.filter(item => item.id == id)[0]
    return <div style={{border:"none", backgroundColor:"transparent", userSelect:"none",
      paddingTop:"0px", marginTop:"0px", height:"15px",  color: "rgb(206, 17, 38)", fontSize: 10}} 
      >{error ? error.text: ""}</div>
  
  };

  const fireOtherEvent = (e, detail, typeValidation) => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(e.target.value, detail, typeValidation, userData) 
    setUser(userData);
  }

  const fireEventKeyPress = (e, detail, typeValidations) => {
     
    var userData = JSON.parse(JSON.stringify(user));
    userData.errors = userData.errors.filter(error => error.id != detail.id )

    if(typeValidations,  !isInputValid({value: e.key}, typeValidations).isValid) {
      e.preventDefault()
    }
    setUser(userData);
  }

  const validInput = (value, detail, typeValidation, userData) => {
    const eventResponse = isInputValid({value: value}, typeValidation);
    if(eventResponse.isValid) {
      userData.errors = userData.errors.filter(error => error.id != detail.id )
    }
    else {
      userData.errors.push({id:detail.id
        , text: eventResponse.type == "EMAIL" ? "The email is invalid" : "The field is required".replace("field", detail.name)})
    }
  }

  const onClick = () => {
  
    var userData = JSON.parse(JSON.stringify(user));
    validInput(user.email, {id:"Email", name:"Email" }, [{type :"REQUIRE"}], userData) 
    if (userData.errors.length == 0) {
      var userData = JSON.parse(JSON.stringify(user));
      setUser({...userData, loading:true })
      axiosOperation({method:"POST"
        , url: "https://flex-services.onrender.com/password/"
        , body:userData
        }).then(response => 
          { 
            if(response.managedError) {
              const result = response.result.data
              setUser({...userData, log:{type:result.log.type, text:result.log.text, style:result.log.style}})
            }
            else {
              setUser({...userData, log:{text:response.text, style:{fontSize:"12px", color:"rgb(206, 17, 38"}}})
            }
          })
     
    } else setUser(userData);
  }

  const canClick = user.errors.length == 0  && !user.loading
  
  return (
    <div style = {{ marginLeft:"auto", marginRight:"auto",width:"250px"
    , padding: "20px", borderRadius: "4px"
    , marginTop:"50px" , backgroundColor: "white" }}>
      <div style = {{ display:"flex"  }}>
        <span style = {{ fontFamily:"Verdana",fontSize:"16px"  }} >Reset Password</span>
        <div style = {{ marginLeft:"10px"  }}>
        { user.loading ? <SpinnerIcon /> : (user.log ? getLogIcon(user.log.type) : null)}
        </div>
      </div>
      <div style = {{  marginTop:"5px"  }}>
      { user.log ? <span style = {user.log.style} >{user.log.text}</span> : 
        <span style = {{ fontSize:"12px" }} >Please enter the email adress that you used to register, and we will send you a link to reset your password via Email.</span>
      }
      </div>
     
      <input id="Email" type="textBox" placeholder="Email" value={user.email} 
        onChange={(e)=> setUser({...user, email:e.target.value})}
        onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
        onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
        style = {{marginTop:"15px"  }}
        className="input connexionInput" />
      {getError("Email")}
      
      <input disabled={!canClick} type="button" className="button" 
          style = {{ height:"30px", width:"250px", marginTop:"5px", backgroundColor:canClick ? "#008dff" : "lightGray" }} 
          onClick = {(e) => onClick(e)}
          value="Reset" />
    </div>
  );
};

